<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :viewBox="viewBox">
    <defs>
      <path id="a" d="M0 0h22v15H0z" />
    </defs>
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        :fill="iconColor"
        d="M11 4.5c-1.655 0-3 1.345-3 3s1.345 3 3 3 3-1.345 3-3-1.345-3-3-3m0 8c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5M11 0C6 0 1.73 3.11 0 7.5 1.73 11.89 6 15 11 15c5.005 0 9.27-3.11 11-7.5C20.27 3.11 16.005 0 11 0"
      />
    </g>
  </svg>
</template>
<script>
  export default {
    name: 'icon-open',
    props: {
      width: {
        type: [Number, String],
        default: 22
      },
      height: {
        type: [Number, String],
        default: 15
      },
      viewBox: {
        type: String,
        default: '0 0 22 15'
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
